import { buildQueryKey } from '@webapp/core/utils/react-query/buildQueryKey'
import { getOrderRequestFlowPreferenceUseCase } from '../business-logic/use-cases/GetOrderRequestFlowPreferenceUseCase'

const base = ['user-preference']

export const userPreferenceQueryConfig = {
  getOrderRequestFlow: (userId: number) => ({
    queryKey: buildQueryKey([...base, 'order-request-flow', userId]),
    queryFn: () => getOrderRequestFlowPreferenceUseCase(userId),
    enabled: !!userId,
  }),
}
